/**
 * Toast Messages Constants
 * Contains all toast notifications, availability messages, and related functions
 */

export const MESSAGE_RESPONSE_GROWTH_ROUTE = {
  ROUTE_UPDATE_CONFIRMATION: {
    backendMessage: 'The goals assigned has been updated',
    type: 'success',
    title: 'Ruta actualizada con éxito',
    description: 'Listos para seguir creciendo 🚀',
  },
  ROUTE_UPDATE_ERROR: {
    backendMessage: '',
    type: 'warning',
    title: 'La ruta no ha sido actualizada',
    description: 'Intenta de nuevo mas tarde',
  },
  OBJECTIVE_DETAIL_ERROR: {
    type: 'warning',
    title: 'Error al cargar detalle',
    description: 'No se pudo cargar el detalle del objetivo. Intenta de nuevo.',
  },
  ACTIVITY_STATUS_UPDATED: {
    type: 'success',
    title: 'Estado actualizado',
    description: 'El estado de la actividad se ha actualizado correctamente.',
  },
  ACTIVITY_STATUS_ERROR: {
    type: 'warning',
    title: 'Error al actualizar estado',
    description: 'No se pudo actualizar el estado de la actividad. Intenta de nuevo.',
  },
  OBJECTIVE_COMPLETED: {
    type: 'success',
    title: 'Objetivo completado',
    description: 'El objetivo ha sido marcado como completado exitosamente.',
  },
  OBJECTIVE_COMPLETED_ERROR: {
    type: 'warning',
    title: 'Error al completar objetivo',
    description: 'No se pudo marcar el objetivo como completado. Intenta de nuevo.',
  },
  ACTIVITY_ATTACHMENTS_UPDATED: {
    type: 'success',
    title: 'Actividad actualizada con éxito',
    description: 'Listos para seguir creciendo 🚀',
  },
  ACTIVITY_ATTACHMENTS_UPDATE_ERROR: {
    type: 'warning',
    title: 'Error al actualizar',
    description: 'No se pudieron guardar los archivos adjuntos. Inténtalo de nuevo.',
  },
  ACTIVITY_DETAIL_LOAD_ERROR: {
    type: 'warning',
    title: 'Error al cargar actividad',
    description: 'No se pudo cargar el detalle de la actividad. Inténtalo de nuevo.',
  },
  ACTIVITY_VISIBILITY_UPDATE_SUCCESS: {
    type: 'success',
    title: 'Visibilidad actualizada',
    description: 'La visibilidad de la actividad se ha actualizado correctamente.',
  },
  ACTIVITY_VISIBILITY_UPDATE_ERROR: {
    type: 'warning',
    title: 'Error al actualizar visibilidad',
    description: 'No se pudo actualizar la visibilidad de la actividad. Intenta de nuevo.',
  },
  PRIORITIZATION_TRIGGERED: {
    type: 'success',
    title: 'Priorizando objetivos',
    description: 'El priorizador está optimizando tu ruta de crecimiento.',
  },
  PRIORITIZATION_TRIGGER_ERROR: {
    type: 'warning',
    title: 'Error al priorizar',
    description: 'No se pudo disparar el priorizador. Intenta de nuevo.',
  },
};

export const MESSAGE_CONFIRMATION = {
  ROUTE_UPDATE_CONFIRMATION: {
    title: '¿Quieres descartar los cambios?',
    description: 'Has realizado cambios en esta ruta. Si no los guardas, se perderán para siempre.',
  },
};

export const TOAST_MESSAGE_VALORATION = {
  WITHOUT_SENIORITY: {
    type: 'warning-process',
    title: 'Este mapa no cuenta con este seniority',
    description:
      'Actualmente, este chapter no tiene habilitado el nivel. Te invitamos a continuar con la valoración en los demás seniorities disponibles.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
};

export const TOAST_MESSAGES_GROWTH_ROUTE = {
  MY_PROFILE: {
    type: 'warning-process',
    title: 'Aún no tienes una ruta de crecimiento',
    description:
      'Todavía no se ha definido tu ruta de crecimiento para cerrar tus brechas. Tu valorador está trabajando en crear un plan personalizado para que puedas avanzar en tu crecimiento. Recibirás una notificación cuando esté lista.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
  EVALUATOR_MESSAGE: {
    type: 'warning-process',
    title: 'Aún no tienes una ruta de crecimiento creada',
    description:
      'Este pragmático no tiene una ruta definida para cerrar sus brechas. Ayúdalo a avanzar creando una ruta personalizada que lo guíe hacia su crecimiento.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
  CUSTOM_GOAL_CREATED: {
    type: 'success',
    title: 'Objetivo creado con éxito',
    description: 'Listos para seguir crecimiento 🚀',
  },
};

export const TOAST_MESSAGES_ASSESSMENT_NO_FOUND = {
  MY_PROFILE: {
    type: 'warning-process',
    title: 'Aún no tienes una valoración registrada',
    description:
      'Todavía no se ha realizado una valoración en tu perfil de Creci. Esto significa que no hay datos disponibles para mostrar tu progreso. Revisa tu mapa de crecimiento actual y asegúrate de tener la información necesaria para cuando inicie tu proceso de valoración.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
  EVALUATOR_MESSAGE: {
    type: 'warning-process',
    title: 'Este pragmático aún no tiene una valoración en Creci',
    description:
      'Todavía no se ha registrado una valoración para este pragmático. Al iniciar el proceso, no contarás con datos históricos de valoraciones anteriores. Es necesario que cargues la información inicial para que el sistema pueda generar un seguimiento adecuado del crecimiento',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
};

export const TOAST_MESSAGES_CHAPTER_NOT_CONFIGURED = {
  MY_PROFILE: {
    type: 'warning-process',
    title: 'Aún no tienes un chapter asignado',
    description:
      'Todavía no se ha registrado un chapter en tu perfil de Creci. Esto significa que no hay datos disponibles para mostrar tu progreso.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
  EVALUATOR_MESSAGE: {
    type: 'warning-process',
    title: 'Este pragmático aún no tiene un chapter asignado en Creci',
    description:
      'Todavía no se ha registrado un chapter para este pragmático. Esto significa que no hay datos disponibles para mostrar el progreso del pragmatico.',
    closeBtnIsActive: false,
    button: null,
    timer: 10,
  },
};

export enum ToastMessages {
  YourPartialReviewHasBeenSavedYouCanReturnToAndEndThisReviewAtAnyTime = 'Tu valoración parcial se ha guardado. Puedes retomar y finalizar esta valoración en cualquier momento.',
  SavedValoration = 'Valoracion guardada',
  SuccessfullyEditedAchievement = 'Se editó el logro correctamente',
  EditedAchievement = 'Logro editado',
  AchievementCreatedSuccessfully = 'Se creó el logro correctamente',
  UpdateTheListOfAchievementsOrContactTheOrganizationalAdministrator = 'Actualiza la lista de logros o contáctese con el Administrador Organizacional',
  NoMoreAchievementsFound = 'No se encuentran más logros',
  AchievementCreated = 'Logro creado',
  LevelChangesAreNowAvailableInTheGeneralScorePanel = 'Ya están disponibles los cambios de nivel en el panel general de puntajes',
  SavedChanges = 'Cambios guardados',
  NewLevelCreatedSuccessfully = 'Nuevo nivel creado exitosamente',
  YouWillSeeItInTheLevelSection = 'Lo verás en la sección de nivel',
  AnErrorOccurredOnTheServerPleaseTryAgainLater = 'Se presentó un error en el servidor. Por favor, inténtalo más tarde.',
  ReportSent = '¡Informe enviado!',
  AchievementEntered = 'Logro ingresado',
  ThisAchievementHasAlreadyBeenProcessedBySomeoneElse = 'Este logro ya fue procesado por alguien más',
  RefreshThePageToSeeTheMostRecentChanges = 'Actualiza la página para ver los cambios más recientes',
  StartedValoration = 'Valoracion iniciada',
  sendAutoValoration = '¡Autovaloración enviada!',
  readyToGrow = 'Listos para seguir creciendo 🚀',
  ResumeAutovaloration = 'Valoración reanudada',
  CanResume = 'Ya puedes continuar valorando las competencias de',
  CanResumeYourOwn = 'Ya puedes continuar valorando tus competencias',
  Saved = 'guardada',
  AnyMoment = 'en cualquier momento.',
  Message = 'parcial se ha guardado. Puedes retomar y finalizar esta',
  SendedValoration = '¡Valoración enviada!',
  CreatedBehavior = 'Comportamiento creado con éxito',
  CreatedPragmaPower = 'Pragmapower creado con éxito',
  DeleteBehavior = '¡Comportamiento eliminado del carrito!',
  ExistBehaviorMap = 'Este comportamiento ya existe en el mapa',
  CreateBehaviorCArt = '¡Comportamiento agregado al carrito!',
  CantSendReport = 'No pudimos enviar tu informe',
  GrowthMapDoesntExist = 'El mapa de crecimiento del pragmático no existe en la carpeta correspondiente al chapter',
  ServerError = 'Error en el servidor',
  RefresgPage = 'Recargar página',
  SendedValorationToLider = 'Valoración enviada a manager',
  AprovedValoration = 'Valoración aprobada',
  RegectedValoration = 'Valoración enviada a revisión',
  RegectedByLeader = 'Valoración rechazada por el manager',
  ApprovedValorationByLeader = 'Valoración aprobada por el manager',
  RetryAfterReview = 'El resultado de la review de crecimiento fue rechazado por el manager, revisa el resultado y envíalo nuevamente.',
  ChangesSaved = '¡Cambios guardados con éxito!',
  ServerErrorDescription = 'Se presentó un error en el servidor, por favor inténtalo más tarde.',
  ProcessingDocument = 'Documento en proceso',
  ProcessingDocumentDescription = 'El documento se encuentra en proceso. Por favor espere unos minutos y recargue nuevamente la página.',
  ErrorSendingAssessment = '¡Error al enviar valoración!',
  RecommendationRequired = 'La recomendación para el pragmatico debe ser obligatoria ',
  VALORATION_REJECTED_BY_TEAM_LIDER = 'Revisa de nuevo la valoración',
  AchievementReview = 'Revisión de Logros',
  assessmentDeadlinePassedTitle = 'La fecha límite para realizar la review de crecimiento ya ha pasado',
  AchievementReviewDescription = 'Podrás agendar tu review de crecimiento, pero aún no has alcanzado los puntos necesarios para avanzar al siguiente nivel.<br>Revisa tus logros pendientes y complétalos para avanzar.',
  assessmentDeadlinePassedDescription = 'La fecha limite para agendar tu review de crecimiento ha expirado. Si deseas continuar con el proceso, por favor contacta a tu líder de chapter.',
  MandatorySenioritySelection = 'Necesitas elegir un seniority y un nivel',
  ConnectionError = 'Error de Conexion',
  ConnectionErrorDescription = 'Parece que tu conexión a internet se ha perdido. Verifica tu conexión antes de recargar la página, ya que podrías perder cualquier progreso realizado.',
  GoalArchivedTitle = 'Objetivo archivado',
  CreateAttachment = '¡Evidencia guardada con éxito!',
  DraftSaveSuccessMessage = 'El mapa ha sido guardado con éxito',
  ErrorCreateDraftTitle = 'Error al crear borrador',
  ErrorCreateDraftDescription = 'No fue posible crear el borrador. Intenta nuevamente.',
  InfoNoChangesTitle = 'Sin cambios',
  InfoNoChangesDescription = 'No hay cambios pendientes para guardar.',
  ErrorSaveTitle = 'Error al guardar',
  ErrorSaveDescription = 'No se guardaron los cambios.',
  BehaviorsAdded = 'Comportamientos agregados',
  AssessmentVersionScheduled = 'La versión de review de crecimiento ha sido programada con éxito',
  VersionUptated = 'La versión de review de crecimiento se ha actualizado con éxito',
  ErrorLoadDatesTitle = 'Error al cargar fechas',
  ErrorLoadDatesDescription = 'No se pudieron obtener las fechas sugeridas de publicación.',
  PublishErrorTitle = 'Error de Publicación',
  PublishConflictDescription = 'Ya existe un mapa en estado programado para este Chapter y especialidad.',
  PublishErrorGeneralDescription = 'No se pudo programar la publicación del mapa.',
  MapVersionPublishedImmediately = 'La versión del mapa ha sido publicada con éxito',
  ImmediatePublishErrorDescription = 'No se pudo publicar el mapa.',
  ErrorLoadBehavior = 'Error al cargar comportamiento',
  ErrorLoadBehaviorDescription = 'No se obtuvo información para este comportamiento',
  EditedBehavior = 'Comportamiento editado con éxito',
  CreatedMission = 'Misión creada con éxito',
  DuplicateItem = '{entity} "{value}" ya se encuentra seleccionado',
  MissingDataTitle = 'Faltan datos',
  MissingChapterToSave = 'Debes completar el chapter antes de guardar',
  MissingSpecialityToSave = 'Debes completar la especialidad antes de guardar',
  SaveSuccessTitle = 'Informacion guardada',
  ActivityAddedSuccess = 'Actividad agregada con éxito',
  ActivityUpdatedSuccess = 'Actividad actualizada con éxito',
  IncompleteInfoTitle = 'Información incompleta',
  IncompleteInfoDescription = 'Debes completar el paso 1 antes de guardar las seniorities.',
  IncompleteStep1Description = 'Por favor completa el paso 1 antes de guardar.',
  ErrorSaveRoleDescription = 'No se pudo guardar la información del rol.',
  ErrorNetworkDescription = 'Error de conexión. Por favor verifica tu internet e intenta nuevamente.',
  ErrorLoadSenioritiesTitle = 'Error al cargar seniorities',
  ErrorLoadSenioritiesDescription = 'No se pudieron cargar los niveles de seniority.',
  ErrorLoadTeamPragmaPowersTitle = 'Error al cargar comportamientos',
  ErrorLoadTeamPragmaPowersDescription = 'No se pudieron cargar los Team PragmaPowers.',
  WarningTitle = 'Advertencia',
  ErrorLoadAvailableDatesDescription = 'No se pudieron cargar las fechas disponibles. Intenta nuevamente.',
  ErrorLoadReviewerInfoDescription = 'No se pudo obtener la información del evaluador. Intenta nuevamente.',
  AttributesSavedSuccessTitle = 'Atributos guardados',
  AttributesSavedSuccessDescription = 'Los atributos de comportamientos se guardaron correctamente',
  ErrorSavingAttributesTitle = 'Error al guardar atributos',
  MapAndAttributesSavedTitle = 'Mapa actualizado',
  MapAndAttributesSavedDescription = 'El mapa y los atributos se guardaron correctamente',
  MapAndAttributesSaveErrorTitle = 'Error al guardar mapa',
  MapAndAttributesSaveErrorDescription = 'Ocurrió un error durante el proceso de guardado',
  AttributesConfiguredTitle = 'Atributos configurados',
  AttributesConfiguredDescriptionDraft = 'Los cambios se guardarán al presionar "Guardar borrador"',
  AttributesConfiguredDescriptionScheduled = 'Los cambios se guardarán al presionar "Actualizar versión"',
  ErrorLoadAttributesTitle = 'Error al cargar atributos personalizables',
  ErrorLoadThresholdsTitle = 'Error al cargar umbrales',
  ErrorLoadThresholdsDescription = 'No se pudieron cargar los umbrales de ponderación.',
  CartBehaviorLimitReached = 'Límite alcanzado: Puedes añadir hasta 25 comportamientos por carrito. Procesa estos para agregar más.',
}

export enum ToastEntity {
  PROFILE = 'El perfil',
  FOCUSING = 'El enfoque',
  EQUIVALENT_ROLE = 'El rol equivalente',
}

export function getMessageEntity(entity: ToastEntity, value: string | string[]): string {
  const formattedValue = Array.isArray(value) ? value.join(', ') : value;
  return ToastMessages.DuplicateItem.replace('{entity}', entity).replace('{value}', formattedValue);
}

export const getToastMessageDescriptionValorationRejectedByEmail = (email: string) => {
  return `El resultado de la review de crecimiento fue devuelto por el manager ${email}, revisa el resultado y envíalo nuevamente.` as const;
};

export enum AvailabilityMessages {
  NoSchedulesAvailableTitle = 'Lo sentimos, en esta fecha no hay horarios disponibles.',
  NoSchedulesAvailableDescription = 'Selecciona otro día.',
  TimeNoLongerAvailableTitle = 'Lo sentimos, la hora seleccionada dejó de estar disponible.',
  TimeNoLongerAvailableDescription = 'Elige otro horario.',
}
